import { render, staticRenderFns } from "./Load-card.vue?vue&type=template&id=91549450&scoped=true"
import script from "./Load-card.vue?vue&type=script&lang=js"
export * from "./Load-card.vue?vue&type=script&lang=js"
import style0 from "./Load-card.vue?vue&type=style&index=0&id=91549450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91549450",
  null
  
)

export default component.exports